"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PaidPlansSell = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19,12 L19,13 C20.1045695,13 21,13.8954305 21,15 L20,15 C20,14.4477153 19.5522847,14 19,14 L18,14 C17.4477153,14 17,14.4477153 17,15 C17,15.5522847 17.4477153,16 18,16 L19,16 C20.1045695,16 21,16.8954305 21,18 C21,19.1045695 20.1045695,20 19,20 L19,21 L18,21 L18,20 C16.8954305,20 16,19.1045695 16,18 L17,18 C17,18.5522847 17.4477153,19 18,19 L19,19 C19.5522847,19 20,18.5522847 20,18 C20,17.4477153 19.5522847,17 19,17 L18,17 C16.8954305,17 16,16.1045695 16,15 C16,13.8954305 16.8954305,13 18,13 L18,12 L19,12 Z M16,4 C16.5522847,4 17,4.44771525 17,5 L17,6 L19,6 C19.5128358,6 19.9355072,6.38604019 19.9932723,6.88337887 L20,7 L20,10 L19,10 L19,7 L17,7 L17,10 L16,10 L16,5 L7,5 L7,19 L14,19 L14,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,18 L4,18 C3.44771525,18 3,17.5522847 3,17 L3,7 C3,6.44771525 3.44771525,6 4,6 L6,6 L6,5 C6,4.44771525 6.44771525,4 7,4 L16,4 Z M6,7 L4,7 L4,17 L6,17 L6,7 Z M14,11 L14,12 L9,12 L9,11 L14,11 Z M14,9 L14,10 L9,10 L9,9 L14,9 Z M14,7 L14,8 L9,8 L9,7 L14,7 Z" })));
};
PaidPlansSell.displayName = 'PaidPlansSell';
exports.default = PaidPlansSell;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PaidPlansSell.js.map